export default function mapTaskType(companyId, taskTypeName) {

    taskTypeName = taskTypeName.trim().toLowerCase();

    const taskTypes = gd.session.taskTypes.filterByCompany(companyId);

    if (taskTypes) {
        const taskType = _.find(taskTypes.models,taskType=>{
            return taskType.name.trim().toLowerCase()===taskTypeName;
        });
        if (taskType) return taskType.id;
    }

    return null;



}